import actions from '@/core/store/relatorios/painel/actions'

export default {
	actions,
}
